import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { useLocation } from "react-router-dom";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import SEO from "./seo.component";
import pageSEO from "../constants/pageSEO";

export default function About() {
  const { state } = useLocation();

  const seoConfig = pageSEO.about();

  return (
    <>
      <SEO {...seoConfig} />
      <div className="max-w-[1100px] mx-auto gap-x-20 gap-y-10 px-6 grid sm:grid-cols-2 mb-12 min-h-[70vh] pt-[150px]">
        <div>
          <img src={constants.HEADSHOT} className="w-full rounded-xl" />
          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black text-3xl">{constants.AGENT_NAME}</h2>
            {/* <p className="italic text-lg">{constants.AGENT_TITLE}, {constants.BROKERAGE}</p> */}

            <div className="flex gap-x-5 my-2">
              {Object.entries(constants.SOCIALS ?? {}).filter(([k, v]) => v !== "")?.map(([k, v]) => (
                <a href={constants.SOCIALS[k]}>
                  <FontAwesomeIcon
                    className="fa-xl text-logo-second"
                    icon={constants.ICONS[k]}
                  />
                </a>
              ))}
            </div>
            <p className="font-semibold text-lg">
              <FontAwesomeIcon icon={faPhone} className="pr-2" />
              {constants.AGENT_NUMBER}{" "}
            </p>
            <p className="text-lg">
              <FontAwesomeIcon icon={faEnvelope} className="pr-2" />
              {constants.AGENT_EMAIL}{" "}
            </p>
          </div>
        </div>
        <div>
          <h1 className="text-4xl text-black pb-8 font-mont ">ABOUT ME</h1>

          {constants.FULL_ABOUT ? (
            constants.FULL_ABOUT.split("<|>").map((p) => (
              <p>
                {p}
                <br />
                <br />
              </p>
            ))
          ) : (
            <p>Coming Soon</p>
          )}
        </div>
      </div>
    </>
  );
}
